import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { StreamService } from '../stream.service';
import { StreamDto } from '../model';

@Component({
  selector: 'app-stream',
  templateUrl: './stream.component.html',
  styleUrls: ['./stream.component.css']
})
export class StreamComponent implements OnInit {
  streamAvailable: boolean;
  streamUrl: string;

  constructor(private sanitizer: DomSanitizer, private streamService: StreamService) {
    this.streamAvailable = false;
    this.streamUrl = '';
  }

  get safeStreamUrl() {
    return this.sanitizer.bypassSecurityTrustResourceUrl(this.streamUrl);
  }

  async ngOnInit() {
    const streamData: StreamDto = await this.streamService.getStreamData();
    this.streamAvailable = streamData.available;
    this.streamUrl = streamData.url;
  }

}
